import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.other.spacing._16,
    padding: 0,
    borderRadius: theme.radius.lg,

    '&.withHeader': {
      backgroundColor: theme.white,
      padding: theme.other.spacing._16,
    }
  },

  pillContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.other.spacing._8,
  },

  pillBase: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.other.spacing._8,
    height: 36,
    padding: theme.other.spacing._12,
    borderRadius: theme.radius.lg,
    backgroundColor: theme.white,
    color: theme.colors.gray2[7],
    border: `1px solid ${theme.colors.gray2[0]}`,
    whiteSpace: 'nowrap',

    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
  pillSelected: {
    backgroundColor: theme.colors.gray2[0],
  },
  pillCount: {
    color: theme.colors.gray2[4],
    backgroundColor: theme.colors.blue[1],
    padding: theme.other.spacing._6,
    borderRadius: theme.radius.lg,
    minWidth: theme.other.spacing._16,
    height: theme.other.spacing._16,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  viewAllButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.other.spacing._32,
    height: theme.other.spacing._32,
    borderRadius: theme.radius.lg,
    color: theme.colors.gray2[7],
    marginLeft: 'auto',
    marginRight: -theme.other.spacing._8,

    transition: 'background-color 0.2s ease-in-out',

    '&:hover': {
      backgroundColor: theme.colors.gray2[0],
    },
  },
}));
